import React from "react";
import { useParams, Link } from "react-router-dom";
import { servicesData } from "../data/servicesData";
import { FAQ } from "./FAQ";
import "./ServiceDetail.css";

export const ServiceDetail = () => {
  const { id } = useParams();
  const service = servicesData.find((s) => s.id === id);

  if (!service) {
    return <div className="service-detail-container">Service not found</div>;
  }

  return (
    <div className="service-detail-page">
      <div className="service-detail-container">
        <Link to="/" className="back-link">← Back to Home</Link>
        <div className="service-header">
          <span className="service-icon-large">{service.icon}</span>
          <h1>{service.title}</h1>
        </div>
        <div className="service-content">
          <p className="service-full-description">{service.fullDescription}</p>
          
          <h3>What's Included:</h3>
          <ul className="service-features">
            {service.features && service.features.map((feature, index) => (
              <li key={index}>{feature}</li>
            ))}
          </ul>

          {service.note && <p className="service-note">{service.note}</p>}
          
          {service.faq && <FAQ items={service.faq} />}

          <div className="cta-container">
             <Link to="/#contact" className="book-now-btn">Book This Service</Link>
          </div>
        </div>
      </div>
    </div>
  );
};
